import { List } from "./list";
import { cr } from "fire-wind-water";

class Checkbox extends List {
  constructor(field: unknown) {
    super(field);
    this.displaySelectType = "CHECKBOX";
  }

  setValue(o, c): void {
    const item = this.listOptions.filter((d) => {
      return d.optionId === o.optionId;
    })[0];
    if (!item) {
      console.error("Fuck, no options found");
      return;
    }
    item.checked = c;
    this.value = [];
    this.label = [];
    this.model = [];
    this.otherValue = [];
    cr.each(this.listOptions, (d) => {
      d.disabled = false;
      if (d.checked) {
        if (
          this.selectOptionLimit > 0 &&
          this.value.length >= this.selectOptionLimit
        ) {
          return;
        }
        this.value.push(d.optionValue);
        this.label.push(d.optionId);
        this.model.push(d);
        if (d.otherisFillIn == 1) {
          this.otherValue.push({ [d.optionValue]: d.otherValue });
        }
      }
    });
    if (
      this.selectOptionLimit > 0 &&
      this.value.length >= this.selectOptionLimit
    ) {
      cr.each(this.listOptions, (d) => {
        if (!d.checked) {
          d.disabled = true;
        }
      });
    }
    this.dirty = true;
    this.isError();
  }

  initDefault(): void {
    cr.each(this.listOptions, (d) => {
      if (d.isDefault == 1) {
        d.checked = true;
        this.value.push(d.optionValue);
        this.label.push(d.optionId);
        this.model.push(d);
      }
    });
    this.dirty = false;
  }

  clearValue(): void {
    this.value = [];
    this.label = [];
    this.model = [];
    this.otherValue = [];
    this.dirty = false;
    cr.each(this.listOptions, (d) => {
      d.checked = false;
      d.disabled = false;
      if (d.otherisFillIn == 1) {
        d.otherValue = null;
      }
      if (d.isDefault === 1 || d.isDefault === "1") {
        d.checked = true;
        this.value.push(d.optionValue);
        this.label.push(d.optionId);
        this.model.push(d);
      }
    });
  }

  setOtherValue(id, val): void {
    const item =
      this.listOptions.filter((d) => {
        return d.optionId == id;
      })[0] || {};
    item.otherValue = val;
    item.dirty = true;
    this.otherValue = [];
    cr.each(this.listOptions, (d) => {
      if (d.checked) {
        if (d.otherisFillIn == 1) {
          this.otherValue.push({ [d.optionValue]: d.otherValue });
        }
      }
    });
    this.isError();
  }
}

export { Checkbox };
